class ProfileMethods {

    constructor() {

    }


}

export default ProfileMethods;